// Campus photo for /colleges/simmons-university: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASimmons_University_Main_College_Building.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/simmons-university/; credited under the photo.
const photo = {
    "slug": "simmons-university",
    "alt": "The columned entrance of the Main College Building at Simmons University on the Fenway in Boston",
    "src": "/colleges/simmons-university/campus-1600.webp",
    "srcSmall": "/colleges/simmons-university/campus-800.webp",
    "srcMid": "/colleges/simmons-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/simmons-university/og.jpg",
    "title": "Simmons University Main College Building",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASimmons_University_Main_College_Building.jpg",
    "read": "2026-10-01"
};

export default photo;
